import { post } from './request';

export async function uploadImages(imgArr: any[], ref: string, id: string | Blob, url: any) {
  const promises: any = [];
  imgArr.forEach((img: any) => {
    const formData = new FormData();
    formData.append(ref, id);
    formData.append('file', img);
    promises.push(post(url, formData, { 'Content-Type': 'multipart/form-data' }));
  });
  await Promise.all(promises);
}
